import Button from 'atoms/Button/button';
import FormField from 'components/community/common/FormField';
import { getAmbienceColorId } from 'components/community/common/utils';
import TimePicker from 'components/general/Form/TimepPicker';
import { Box, FlexDiv } from 'components/molecules/utils/basicComponents';
import { getCustomScroll } from 'components/molecules/utils/customStyles';
import { utcToZonedTime } from 'date-fns-tz';
import add from 'date-fns/add';
import endOfDay from 'date-fns/endOfDay';
import { Typography } from 'foundations/typography';
import useTheme from 'hooks/useTheme';
import moment from 'moment';
import React from 'react';
import styled, { css } from 'styled-components';
import { cdnImage } from 'utils/core';
import { StyledSvgSprite } from '../../../../general/SVGSprite';
import { TimeInputBox } from '../commonComponents';

export const StartTime = ({
    formData,
    setShowSideMenu,
    getMinTime,
    onStateChanged,
    showSidemenu,
    disabled,
    inline,
    onClose,
    newOnBoardingFlow = false,
    newOnBoardingFlowSideMenu = false,
    pageMode = false,
    onStartTimeFocus = () => {},
    isCreateAirmeetV3 = false,
}) => {
    const DEFAULT_MAX_TIME = endOfDay(
        utcToZonedTime(add(new Date(), { years: 5 }), formData.timeZone)
    );
    const { theme } = useTheme();
    const getColorId = (colorId) =>
        getAmbienceColorId({
            colorId,
            isAgnostic: newOnBoardingFlowSideMenu,
            theme,
        });

    return (
        <>
            {disabled ? (
                <StyledBox
                    forceDarkMode
                    onClick={() => {
                        onStartTimeFocus();
                        setShowSideMenu('start_time');
                    }}
                >
                    <FormFieldWIcon
                        id={'initTime'}
                        name={'initTime'}
                        custom
                        variant={'v2'}
                        label={`Start time${isCreateAirmeetV3 ? '*' : ''}`}
                        subLabel={
                            pageMode || isCreateAirmeetV3
                                ? ''
                                : 'Event start time'
                        }
                        forTimePicker
                        className={showSidemenu === 'start_time' && 'active'}
                        showSidemenu={showSidemenu !== ''}
                        newOnBoardingFlow={newOnBoardingFlow}
                        pageMode={pageMode}
                    >
                        <TimeInputBox>
                            {moment(formData.initDate).format('h:mm A')}
                        </TimeInputBox>
                        <StyledSvgSprite
                            position={'absolute'}
                            top={'50%'}
                            // zIndex={'0'}
                            right={'18px'}
                            icon={'icon-time-nofill'}
                            height={16}
                            width={16}
                            fill={'ambience.8'}
                            style={{
                                transform: 'translateY(-50%)',
                            }}
                        />
                    </FormFieldWIcon>
                </StyledBox>
            ) : (
                <>
                    <FlexDiv
                        mb={2}
                        flexDirection={'column'}
                        alignItems={'flex-start'}
                        position={'relative'}
                    >
                        <Typography
                            variant={'subtitle2'}
                            color={`ambience.${getColorId('23')}`}
                            mb={2}
                        >
                            Start Time
                        </Typography>
                        <Typography
                            variant={'caption-light'}
                            color={`ambience.${getColorId('14')}`}
                        >
                            Set the start time for your event
                        </Typography>
                        <ButtonClose variant={'link'} onClick={onClose}>
                            <StyledSvgSprite
                                icon={'icon-times'}
                                height={'24px'}
                                width={'24px'}
                                fill={`ambience.${getColorId('23')}`}
                            />
                        </ButtonClose>
                    </FlexDiv>
                    <SidebarBox
                        forceDarkMode={newOnBoardingFlowSideMenu ? false : true}
                        verticalWidth={'12px'}
                        newOnBoardingFlowSideMenu={newOnBoardingFlowSideMenu}
                        ambienceColorId={getColorId}
                    >
                        <TimePicker
                            name={'initTime'}
                            placeholder={'Select Start Time'}
                            defaultTime={formData.initDate}
                            min={getMinTime('initTime')}
                            max={DEFAULT_MAX_TIME}
                            onChange={onStateChanged('initTime')}
                            popperClassName={'custom-time-dropdown'}
                            inline={inline}
                            disabled={disabled}
                        />
                    </SidebarBox>
                </>
            )}
        </>
    );
};
const SidebarBox = styled(FlexDiv)`
    > div {
        width: 100%;
    }
    .react-datepicker--time-only {
        margin-top: 0px !important;
        width: 100%;
        max-width: 100%;
        z-index: 2;
        &.react-datepicker {
            font-family: ${({ theme }) => theme.fonts.book};
            border-radius: 0px !important;
            overflow: hidden;
            border: 0;
            background-color: transparent;
            width: 100%;
            .react-datepicker__time-container {
                width: 100%;
                .react-datepicker__header--time {
                    display: none;
                }
                .react-datepicker__time {
                    background-color: transparent;
                    border-radius: 0;
                    .react-datepicker__time-box {
                        width: 100%;
                        border-radius: 0px !important;
                        .react-datepicker__time-list {
                            ${({ theme, forceDarkMode, verticalWidth }) =>
                                getCustomScroll({
                                    theme,
                                    forceDarkMode,
                                    verticalWidth,
                                })};
                            max-height: calc(100vh - 142px);
                            height: 100%;
                            overflow-y: auto;
                            padding: 0px 0;
                            .react-datepicker__time-list-item {
                                width: 100%;
                                margin: 0;
                                padding: 10px 16px;
                                height: unset;
                                font-size: 14px;
                                line-height: 16px;
                                text-align: left;
                                transition: all 0.3s ease-in-out;
                                text-transform: lowercase;
                                position: relative;
                                color: ${({ theme, ambienceColorId }) =>
                                    theme.colors.ambience[ambienceColorId(18)]};
                                &.react-datepicker__time-list-item--disabled {
                                    opacity: 0.5;
                                    &:hover {
                                        background-color: transparent;
                                    }
                                }
                                &.react-datepicker__time-list-item {
                                    background-color: transparent;
                                }
                                &:hover {
                                    background-color: ${({
                                        theme,
                                        ambienceColorId,
                                    }) =>
                                        theme.colors.ambience[
                                            ambienceColorId(3)
                                        ]};
                                }
                                &.react-datepicker__time-list-item--selected {
                                    &:after {
                                        content: '';
                                        ${({ newOnBoardingFlowSideMenu }) =>
                                            newOnBoardingFlowSideMenu
                                                ? css`
                                                      background: url('${cdnImage(
                                                          '/images/dashboard/checkmark-circle-primary.svg'
                                                      )}')
                                                          center no-repeat;
                                                  `
                                                : css`
                                                      background: url('${cdnImage(
                                                          '/images/dashboard/checkmark-circle.svg'
                                                      )}')
                                                          center no-repeat;
                                                  `}
                                        height: 24px;
                                        width: 24px;
                                        position: absolute;
                                        transform: translateY(-50%);
                                        top: 50%;
                                        left: 100px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .react-datepicker__triangle {
                display: none;
            }
        }
    }
`;
const StyledBox = styled(Box)`
    width: 100%;
    max-width: 250px;
    margin-right: 25px;
    &:last-child {
        margin-right: 0;
    }
    .custom-time-dropdown {
        margin-top: 0px !important;
        width: 100%;
        max-width: 100%;
        z-index: 2;
        .react-datepicker {
            font-family: ${({ theme }) => theme.fonts.book};
            background-color: ${({ theme }) => theme.colors.ambience[1]};
            border-radius: 8px;
            overflow: hidden;
            border: 0;
            width: 100%;
            .react-datepicker__time-container {
                width: 100%;
                .react-datepicker__header--time {
                    display: none;
                }
                .react-datepicker__time {
                    background-color: ${({ theme }) =>
                        theme.colors.ambience[1]};
                    border-radius: 0;
                    .react-datepicker__time-box {
                        width: 100%;
                        .react-datepicker__time-list {
                            ${({ theme, forceDarkMode, verticalWidth }) =>
                                getCustomScroll({
                                    theme,
                                    forceDarkMode,
                                    verticalWidth,
                                })};
                            max-height: 164px;
                            overflow-y: auto;
                            padding: 16px 0;
                            .react-datepicker__time-list-item {
                                width: 100%;
                                margin: 0;
                                padding: 10px 16px;
                                height: unset;
                                font-size: 14px;
                                line-height: 16px;
                                text-align: left;
                                transition: all 0.3s ease-in-out;
                                text-transform: lowercase;
                                color: ${({ theme }) =>
                                    theme.colors.ambience[18]};
                                &.react-datepicker__time-list-item--disabled {
                                    opacity: 0.5;
                                    &:hover {
                                        background-color: transparent;
                                    }
                                }
                                &.react-datepicker__time-list-item {
                                    background-color: transparent;
                                }
                                &:first-child {
                                    padding-top: 0;
                                }
                                &:last-child {
                                    padding-bottom: 0;
                                }
                                &:hover {
                                    background-color: ${({ theme }) =>
                                        theme.colors.ambience[2]};
                                }
                            }
                        }
                    }
                }
            }
            .react-datepicker__triangle {
                display: none;
            }
        }
    }
`;

const FormFieldWIcon = styled(FormField)`
    ${({ forTimePicker }) =>
        forTimePicker &&
        `
    &.form-field {
        padding:0 !important;
    }
    .react-datepicker__input-container {
        input {
            cursor: pointer;
            padding: 18px 40px 16px 17px;
        }
    }
    `};
    &.form-field {
        cursor: pointer;
        position: relative;
        ${({ theme, showSidemenu, newOnBoardingFlow, pageMode }) =>
            showSidemenu &&
            !pageMode &&
            `
            &::before{
                content: '';
                position: absolute;
                top: 50%;
                right: -70px;
                opacity: 0;
                height: 48px;
                width: 48px;
                transform: translate(400px,-50%) rotate(45deg);
                border-radius: 4px;
                background-color: ${
                    newOnBoardingFlow
                        ? theme.colors.ambience[22]
                        : theme.colors.ambience[2]
                };
                z-index: 0;
                transition: all 0.35s ease-in-out;
            }
            &.active::before {
                opacity:1;
                transform: translate(0px,-50%) rotate(45deg);
            }
        `};
    }
    .react-datepicker-wrapper {
        width: 100%;
    }
    .react-datepicker__input-container {
        position: relative;
        z-index: 1;
    }
`;
const ButtonClose = styled(Button)`
    position: absolute;
    right: 0px;
    z-index: 1090;
    &:hover {
        opacity: 0.85;
    }
    &:focus {
        outline: 0;
        box-shadow: none;
    }
`;
